import * as React from "react";
import { FreeBetOption } from "../FreeBetOption";
import { Icon } from "sb-resp-ui";
export class FreeBetDropdown extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.changeHandler = (e) => {
            this.props.selectFreeBet(e.target.value);
        };
    }
    render() {
        const { selectedFreeBet, freeBets, useFreeBetPhrase } = this.props;
        return (React.createElement("div", { className: "rj-yourbet__free-bet-dropdown-wrapper" },
            React.createElement("span", { className: "rj-yourbet__free-bet-name", "data-id": selectedFreeBet.id, "data-uat": "bet-slip-free-bet-dropdown-label" }, `${useFreeBetPhrase} ${selectedFreeBet.text}`),
            React.createElement(Icon, { i: "i-o-yourbet-arrow-down  i-18" }),
            React.createElement("select", { className: "rj-yourbet__free-bet-dropdown", "data-uat": "bet-slip-free-bet-dropdown", onChange: this.changeHandler, value: selectedFreeBet.id }, freeBets.map((freeBet, index) => React.createElement(FreeBetOption, { id: freeBet.id, text: freeBet.text, key: `free-bet-dropdown-${index}` })))));
    }
}
//# sourceMappingURL=FreeBetDropdown.js.map